module.exports = __webpack_public_path__ + "img/12.5c85c17a.png";